import { IconButton } from "@nabble/ui";
import { useState } from "react";

const COPIED_FEEDBACK_MS = 1800;

/** Copies the TOTP key to the clipboard and briefly confirms it. Disabled until the key arrives. */
export function CopySecretButton({ secret }: { secret: string | null }): React.JSX.Element {
  const [copied, setCopied] = useState(false);
  return (
    <IconButton
      size="sm"
      icon={copied ? "check" : "copy"}
      label={copied ? "Key copied" : "Copy key"}
      disabled={!secret}
      onClick={() => {
        if (!secret) return;
        void navigator.clipboard?.writeText(secret).then(() => {
          setCopied(true);
          window.setTimeout(() => setCopied(false), COPIED_FEEDBACK_MS);
        });
      }}
    />
  );
}
